var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"new_css"},[_c('iframe',{staticClass:"ifrommy",staticStyle:{"height":"93vh"},attrs:{"src":_vm.path,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }